import { anyReallyAny } from "../tools/object.tools";
import { injector } from "./injector";

/**
 * Decorator that marks a class property as injected as a dependency.
 * Its value will be retrieved from injector.
 * Usage :
 * 
 * @ Injected("AppService")
 * app!: AppService;
 * 
 * or
 * 
 * @ Injected("AppService", { optional : true })
 * app?: AppService;
 * 
 * The service/dependency must be registered before property is get ex: injector.register(new ServerAppService()); (usually in main)
 * 
 * @param interfaceName the provided string can be anything but is usually the interface name of a service.
 */
export function Injected(interfaceName: string, options?: { optional?: boolean }): (classPrototype: unknown, propertyKey: string) => void {

    return (classPrototype: unknown, propertyKey: string): void => {

        // define property returning value stored in injector
        Object.defineProperty(classPrototype, propertyKey, {
            get: (): anyReallyAny => {
                // BGS : do not try to cache injector.get result, I have tested and you won't gain any performance and you will lose the dependency dynamic change feature
                const injected = injector.find(interfaceName);
                if (!options?.optional && injected == null) {
                    throw new Error("@Injected Dependency " + interfaceName + " was not found");
                }
                return injected;
            },
            set: () => {
                console.error("can't set " + propertyKey + " : @Injected properties are readonly");
            }
        });
    };
}